import moduleDoctors from './safety/themeLena/doctors'
import moduleFactors from './safety/themeLena/factors'
import moduleTests from './safety/themeLena/tests'
import moduleWorks from './safety/themeLena/works'
import moduleEmployee from './employee/themeLena'
import moduleMedExam from './medExam/themeLena'
import moduleBriefing from './briefing/themeLena'
import moduleWorkplace from './workplace/themeLena'
import moduleCounterparty from './counterparty/themeLena'
import moduleTrainingApp from './trainingApp/themeLena'
import moduleSummaryDocs from './documents/summaryDoc/themeLena'
import moduleUnits from './unit/themeLena'
import moduleAnthropometry from './anthropometry/themeLena'
import moduleEquipTypes from './equipType/themeLena'
import moduleHazards from './hazard/themeLena'
import moduleProfessions from './profession/themeLena'
import moduleBriefingType from './briefingType/themeLena'
import moduleEquipCert from './equipCert/themeLena'
import moduleCompensation from './compensation/themeLena'
import moduleCourse from './course/themeLena'
import moduleEducation from './education/themeLena'
import moduleLogistics from './logisticalSupport/themeLena'
import moduleInsurance from './documents/insurance/themeLena'
import moduleScore from './score/themeLena'
import moduleWarehouse from './warehouse/themeLena'
import moduleOperations from './warehouse/operations/themeLena/operations'
import moduleOperationsActions from './warehouse/operations/themeLena/operationsActions'
import moduleContract from './contract/themeLena'
import moduleResponsibles from './responsibles/themeLena'
import modulePostTemplate from './postTemplate/themeLena'
import moduleMain from './main/themeLena'
import moduleSchedule from './schedule/themeLena'
import modulePersonalCard from './personalCard/themeLena'
import moduleAccountingForms from './accountingForms/themeLena'

export default [
  moduleDoctors,
  moduleFactors,
  moduleTests,
  moduleWorks,
  moduleEmployee,
  moduleMedExam,
  moduleBriefing,
  moduleWorkplace,
  moduleCounterparty,
  moduleTrainingApp,
  moduleScore,
  moduleSummaryDocs,
  moduleUnits,
  moduleAnthropometry,
  moduleEquipTypes,
  moduleHazards,
  moduleProfessions,
  moduleBriefingType,
  moduleEquipCert,
  moduleCompensation,
  moduleCourse,
  moduleEducation,
  moduleLogistics,
  moduleInsurance,
  moduleWarehouse,
  moduleOperations,
  moduleOperationsActions,
  moduleContract,
  moduleResponsibles,
  modulePostTemplate,
  moduleMain,
  moduleSchedule,
  modulePersonalCard,
  moduleAccountingForms
]
